module.exports = __webpack_public_path__ + "static/media/di6min-min.c20a6054.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/decorating-interiors/di6min-min.jpg
// module id = 236
// module chunks = 0